// extracted by mini-css-extract-plugin
module.exports = {"loadingPage":"loading-page_loadingPage__1SREe","loadingCont":"loading-page_loadingCont__3abmF"};